import { useRendererContext } from './renderer-context';
export const useFeatureFlags = () => {
  var _useRendererContext;
  return (_useRendererContext = useRendererContext()) === null || _useRendererContext === void 0 ? void 0 : _useRendererContext.featureFlags;
};